function normalizeHostname(value) {
  if (!value || typeof value !== "string") return "";
  const s = value.trim();
  try {
    if (/^https?:\/\//i.test(s)) {
      return new URL(s).hostname;
    }
    return s.split("/")[0].toLowerCase();
  } catch {
    return s.split("/")[0].toLowerCase();
  }
}

function getIsProd() {
  const prodHost = normalizeHostname(process.env.REACT_APP_PROD_HOSTNAME);
  if (!prodHost || typeof window === "undefined") return false;
  return window.location?.hostname?.toLowerCase() === prodHost;
}

export const env = {
  get isProduction() {
    return getIsProd();
  },
  get isStaging() {
    return !getIsProd();
  },
};

function normalizeBaseUrl(url) {
  if (!url || typeof url !== "string") return "";
  const s = url.trim();
  return s.endsWith("/") ? s.slice(0, -1) : s;
}

export function getApiBaseUrl() {
  const isProd = getIsProd();
  const url = isProd
    ? process.env.REACT_APP_API_BASE_URL_PROD
    : process.env.REACT_APP_API_BASE_URL_STG;
  return normalizeBaseUrl(url);
}

/** Fallback prod API when primary returns CORS/network error. Prod only. */
export function getApiBaseUrlFallback() {
  if (!getIsProd()) return "";
  return normalizeBaseUrl(process.env.REACT_APP_API_BASE_URL_PROD_2 || "");
}

/** True if error is likely CORS or network (try fallback). */
export function isCorsOrNetworkError(error) {
  if (!error) return false;
  const msg = (error.message || String(error)).toLowerCase();
  return (
    msg.includes("failed to fetch") ||
    msg.includes("networkerror") ||
    msg.includes("load failed") ||
    msg.includes("network request failed") ||
    error.name === "TypeError"
  );
}

export function getGoogleMapsApiKey() {
  return process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
}

/** Google Sign-In Web client ID (GIS). Staging vs prod follows `REACT_APP_PROD_HOSTNAME`. */
export function getGoogleOAuthClientId() {
  const isProd = getIsProd();
  const raw = isProd
    ? process.env.REACT_APP_GOOGLE_CLIENT_ID_PROD
    : process.env.REACT_APP_GOOGLE_CLIENT_ID_STG;
  return typeof raw === "string" ? raw.trim() : "";
}
